// extracted by mini-css-extract-plugin
export default {"container":"TimeDeal_container__1jfOI","inner":"TimeDeal_inner__R+pbs","title":"TimeDeal_title__gKRp1"};